import { Typography, Container, Grid, Button, useTheme, useMediaQuery, Alert } from '@mui/material';
import { FC } from 'react';
import { externalSiteUrl } from 'src/pages/customer-reservation/top';

export const CustomerReservationCancelDone: FC = () => {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const url = sessionStorage.getItem('top-return-url');

  return (
    <Container>
      <Typography variant="h4" color="text.secondary" sx={{ pb: 1, pt: 2, pl: 3 }}>
        キャンセル画面
      </Typography>

      <Grid container spacing={3.5} sx={{ pb: 4 }}>
        <Grid item xs={12}>
          <Typography variant="h3" color="text.secondary" align="center" sx={{ pt: 3 }}>
            予約キャンセル完了
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Alert severity="success" sx={{ mb: 3, mx: 3 }}>
            予約のキャンセルが完了しました
          </Alert>
          <Typography
            variant={isMdUp ? 'subtitle1' : 'subtitle2'}
            color="text.secondary"
            align="center"
            sx={{ pt: isMdUp ? 4 : 1 }}
          >
            キャンセル完了メールが送信されました。メールが届かない場合は、お電話にてご連絡ください。
          </Typography>
        </Grid>
        <Grid item xs={12} sx={{ textAlign: 'center' }}>
          <Button
            variant="contained"
            sx={{ width: 180, height: 47 }}
            size="large"
            onClick={() => {
              window.location.href = url || externalSiteUrl;
            }}
          >
            トップページに戻る
          </Button>
        </Grid>
      </Grid>
    </Container>
  );
};
